import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';
import { useWorkspace } from './workspace';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: true,
      retry: (count, error) =>
        error instanceof ApiError ? (error.status === 0 || error.status >= 500) && count < 2 : count < 1,
    },
    mutations: { retry: false },
  },
});

/** Query keys for tenant data always include the active business id. */
export function bk(...parts: unknown[]): unknown[] {
  return ['b', useWorkspace.getState().businessId, ...parts];
}

/** Invalidates tenant queries whose key starts with the given parts. */
export function invalidate(...parts: unknown[]): Promise<void> {
  return queryClient.invalidateQueries({ queryKey: bk(...parts) });
}

/** Invoices affect almost every summary view; refresh them together after changes. */
export async function invalidateInvoiceViews(): Promise<void> {
  await Promise.all([
    invalidate('invoices'),
    invalidate('invoice'),
    invalidate('dashboard'),
    invalidate('reports'),
    invalidate('payments'),
    invalidate('customers'),
    invalidate('customer'),
    invalidate('recurring'),
  ]);
}
